import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {APP_CONFIG} from '../config/app-config.token';
import {AppConfig} from '../config/app-config.model';
import {InboxMessage} from '../model/inbox-message';
import {HttpHeaderService} from './http-header.service';
import {CapacitorHttpService} from './capacitor-http.service';

@Injectable({
  providedIn: 'root'
})
export class InboxService {
  private http = inject(HttpClient);
  private capacitorHttp = inject(CapacitorHttpService);
  private httpHeaderService = inject(HttpHeaderService);
  private config = inject<AppConfig>(APP_CONFIG);

  baseurl: string;

  constructor() {
    this.baseurl = this.config.apiGatewayUrl;
  }
  getInboxMessages(
    { ssin, status, addAttachment = false }: { ssin: string; status?: string; addAttachment?: boolean }
  ): Observable<InboxMessage[]> {
    let url = `${this.baseurl}/members/${ssin}/inbox?timestamp=${Date.now()}&addAttachment=${addAttachment}`;
    if (status != null) {
      url += '&status=' + status;
    }
    return this.capacitorHttp.get<InboxMessage[]>(url, this.httpHeaderService.getHeaderOptions());
  }

  getOneInboxMessage(ssin: string, msgId: string): Observable<InboxMessage> {
    return this.capacitorHttp.get<InboxMessage>(
      this.baseurl + `/members/${ssin}/inbox/messages/${msgId}`, this.httpHeaderService.getHeaderOptions());
  }

  setInboxMessageStatus(ssin: string, msgId: string, statusId: string): Observable<InboxMessage> {
    return this.capacitorHttp.post<InboxMessage>(this.baseurl + `/members/${ssin}/inbox/messages/${msgId}/status/${statusId}`,
      this.httpHeaderService.getHeaderOptions());
  }

  // ========== METHODS FOR EXTERNAL USERS (using /me endpoints) ==========
  // These methods are for external users (members) who can only access their own data.
  // Tyk API Gateway rewrites /members/me to /members/{jwt.preferred_username}

  /**
   * Get inbox messages for authenticated external user
   * @param status Optional status filter
   * @param addAttachment Whether to add attachment information
   * @returns Observable<InboxMessage[]>
   */
  getMyInboxMessages({ status, addAttachment = false }: { status?: string; addAttachment?: boolean }): Observable<InboxMessage[]> {
    let url = `${this.baseurl}/members/me/inbox?timestamp=${Date.now()}&addAttachment=${addAttachment}`;
    if (status != null) {
      url += '&status=' + status;
    }
    return this.capacitorHttp.get<InboxMessage[]>(url, this.httpHeaderService.getHeaderOptions());
  }

  /**
   * Get one inbox message for authenticated external user
   * @param msgId Message ID
   * @returns Observable<InboxMessage>
   */
  getMyOneInboxMessage(msgId: string): Observable<InboxMessage> {
    return this.capacitorHttp.get<InboxMessage>(
      this.baseurl + `/members/me/inbox/messages/${msgId}`,
      this.httpHeaderService.getHeaderOptions()
    );
  }

  /**
   * Set inbox message status for authenticated external user
   * @param msgId Message ID
   * @param statusId Status ID
   * @returns Observable<InboxMessage>
   */
  setMyInboxMessageStatus(msgId: string, statusId: string): Observable<InboxMessage> {
    return this.capacitorHttp.post<InboxMessage>(
      this.baseurl + `/members/me/inbox/messages/${msgId}/status/${statusId}`,
      this.httpHeaderService.getHeaderOptions()
    );
  }
}
